import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.9719 1.83989L22.3359 2.54699C22.3359 2.54699 23.043 8.91096 15.9719 15.982C8.90087 23.0531 2.53553 22.3474 2.53553 22.3474L1.82843 15.9834L6.77955 13.155L9.25374 15.6292C9.25374 15.6292 11.0215 15.2756 13.1428 13.1543C15.2641 11.033 15.6177 9.2652 15.6177 9.2652L13.1435 6.79101L15.9719 1.83989Z",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }